/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_Chf3Inputs */

const he_currency_chf3 = /** @type {(inputs: Currency_Chf3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CHF - Swiss Franc`)
};

const en_currency_chf3 = /** @type {(inputs: Currency_Chf3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CHF - Swiss Franc`)
};

/**
* | output |
* | --- |
* | "CHF - Swiss Franc" |
*
* @param {Currency_Chf3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const currency_chf3 = /** @type {((inputs?: Currency_Chf3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_Chf3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_currency_chf3(inputs)
	return en_currency_chf3(inputs)
});
export { currency_chf3 as "currency_CHF" }